/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/components/preferencia/preferencia.component';
import * as i4 from '../../../../../src/app/services/common.service';
import * as i5 from '../../../../../src/app/services/shared.service';
import * as i6 from '@angular/router';
var styles_PreferenciaComponent = [];
export var RenderType_PreferenciaComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_PreferenciaComponent, data: {} });
function View_PreferenciaComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'option', [], [[8, 'selected', 0]], null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['\n              ',
            '\n            '])), (_l()(), i0.ɵted(null, ['\n          ']))], function (_ck, _v) {
        var currVal_1 = i0.ɵinlineInterpolate(1, '', _v.context.$implicit.orgId, '');
        _ck(_v, 2, 0, currVal_1);
        var currVal_2 = i0.ɵinlineInterpolate(1, '', _v.context.$implicit.orgId, '');
        _ck(_v, 3, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.$implicit.orgId == _co.preferencia.organismoSeleccionado);
        _ck(_v, 1, 0, currVal_0);
        var currVal_3 = _v.context.$implicit.descripcion;
        _ck(_v, 4, 0, currVal_3);
    });
}
function View_PreferenciaComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'option', [], [[8, 'selected', 0]], null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['\n              ',
            '\n            '])), (_l()(), i0.ɵted(null, ['\n          ']))], function (_ck, _v) {
        var currVal_1 = i0.ɵinlineInterpolate(1, '', _v.context.$implicit.depId, '');
        _ck(_v, 2, 0, currVal_1);
        var currVal_2 = i0.ɵinlineInterpolate(1, '', _v.context.$implicit.depId, '');
        _ck(_v, 3, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.$implicit.depId == _co.preferencia.dependenciaSeleccionada);
        _ck(_v, 1, 0, currVal_0);
        var currVal_3 = _v.context.$implicit.descripcion;
        _ck(_v, 4, 0, currVal_3);
    });
}
function View_PreferenciaComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'option', [], [[8, 'selected', 0]], null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null),
        i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef, i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['\n              ',
            '\n            '])), (_l()(), i0.ɵted(null, ['\n          ']))], function (_ck, _v) {
        var currVal_1 = i0.ɵinlineInterpolate(1, '', _v.context.$implicit.carId, '');
        _ck(_v, 2, 0, currVal_1);
        var currVal_2 = i0.ɵinlineInterpolate(1, '', _v.context.$implicit.carId, '');
        _ck(_v, 3, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.$implicit.carId == _co.preferencia.cargoSeleccionado);
        _ck(_v, 1, 0, currVal_0);
        var currVal_3 = _v.context.$implicit.descripcion;
        _ck(_v, 4, 0, currVal_3);
    });
}
function View_PreferenciaComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 46, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Organismo:'])),
        (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 7, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'select', [['id', 'organismos']], null, [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.onChangeOrg($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n          '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PreferenciaComponent_2)),
        i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Dependencia:'])), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 7, 'span', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'select', [['id', 'dependencias']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PreferenciaComponent_3)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵted(null, ['\n    '])),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Cargo:'])), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 7, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'select', [['id', 'cargos']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_PreferenciaComponent_4)),
        i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.preferencia.organismos;
        _ck(_v, 12, 0, currVal_0);
        var currVal_1 = _co.selectedOrg.dependencias;
        _ck(_v, 27, 0, currVal_1);
        var currVal_2 = _co.preferencia.cargos;
        _ck(_v, 42, 0, currVal_2);
    }, null);
}
export function View_PreferenciaComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h1', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Preferencias'])), (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_PreferenciaComponent_1)), i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.preferencia;
        _ck(_v, 6, 0, currVal_0);
    }, null);
}
export function View_PreferenciaComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'my-app', [], null, null, null, View_PreferenciaComponent_0, RenderType_PreferenciaComponent)),
        i0.ɵdid(114688, null, 0, i3.PreferenciaComponent, [i4.CommonService, i5.SharedService,
            i6.Router, i6.ActivatedRoute], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var PreferenciaComponentNgFactory = i0.ɵccf('my-app', i3.PreferenciaComponent, View_PreferenciaComponent_Host_0, {}, {}, []);
//# sourceMappingURL=preferencia.component.ngfactory.js.map